import { useTranslation } from 'react-i18next';
import { Alert } from 'ui';

type P = {
  isAdmin: boolean;
};

const ApprovalAlert = ({ isAdmin }: P) => {
  const { t } = useTranslation();

  return (
    <>
      {isAdmin ? (
        <Alert
          description="Make sure this is intentional."
          title={t('You are inviting more than {{count}} invitees!', { count: 25 })}
          type="warning"
        />
      ) : (
        <Alert
          description="This requires approval from the admin. During approval process, event cannot be changed."
          title={t('You are inviting more than {{ count }} invitees!', {
            count: 25,
          })}
          type="warning"
        />
      )}
    </>
  );
};

export default ApprovalAlert;
